<template>
<div class="settings-dialog">
  <v-dialog v-model="dialog" width="300">
    <template v-slot:activator="{ on }">
      <v-btn text icon>
        <v-icon class="settings-icon" v-on="on">mdi-wrench</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        {{ $t('settings.label') }}
      </v-card-title>
      <v-list class="pt-0">
        <v-list-tile>
          <v-switch @change="switchDarkTheme" :input-value="dark" append-icon="mdi-weather-night" :label="`${$t('settings.dark-theme')}`" hide-details></v-switch>
        </v-list-tile>
        <v-list-tile>
          <v-switch @change="switchFormAutor" :input-value="formFullName" :label="`${$t('settings.form-fullname')}`" hide-details></v-switch>
        </v-list-tile>
        <v-list-tile>
          <v-select :items="[5, 10, 20, 50]" :value="defaultRowsPerPage" @change="changeDefaultTableRowsAmount($event)" :label="`${$t('settings.default-rows-amount')}`"></v-select>
        </v-list-tile>
        <v-list-tile>
          <v-select :items="['pl','en','nl']" :value="$store.getters.lang" @change="changeLanguage($event)" :label="`Język`"></v-select>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import Cookies from 'js-cookie'
import Langs from '@/plugins/langs'
export default {
  data() {
    return {
      dialog: false,
      langs: Langs.getSupportedLangs()
    }
  },
  computed: {
    formFullName(){
      return Cookies.get('fullnameautor') == 'true'
    },
    dark() {
      return this.$store.getters.darkTheme
    },
    defaultRowsPerPage() {
      return parseInt(this.$store.getters.pagination.rowsPerPage)
    },
  },
  methods: {
    switchDarkTheme() {
      this.$store.commit("switchDarkTheme")
    },
    changeDefaultTableRowsAmount($event) {
      this.$store.commit("changeDefaultTableRowsAmount", $event)
    },
    changeLanguage($event) {
      this.$store.commit("changeLanguage", $event)
    },
    switchFormAutor($event){
      Cookies.set("fullnameautor", $event)
    }
  }
}
</script>

<style scoped>
.settings-icon {
  opacity: 0.7;
}

.headline {
  padding-bottom: 0;
}
</style>
